"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../utils/classFunctions");
const Icon_1 = require("../Icon");
require("./index.scss");
const className = 'button';
const Button = (props) => {
    const { icon, iconRight, onClick, text, type = 'submit', disabled, hidden, additionClassNames, modificators, } = props;
    const classNames = (0, classFunctions_1.getClassNames)(className, [
        modificators,
        !text ? 'no-text' : undefined,
    ], additionClassNames);
    if (hidden)
        return null;
    return (react_1.default.createElement("button", { className: classNames, disabled: disabled, onClick: onClick, type: type },
        icon && (react_1.default.createElement("span", { className: `${className}__icon` },
            react_1.default.createElement(Icon_1.Icon, { name: icon }))),
        text && (react_1.default.createElement("span", { className: `${className}__text` }, text)),
        iconRight && (react_1.default.createElement("span", { className: `${className}__icon-right` },
            react_1.default.createElement(Icon_1.Icon, { name: iconRight })))));
};
exports.Button = Button;
//# sourceMappingURL=index.js.map